import { Component, OnInit } from '@angular/core';
import { NavParams } from '@ionic/angular';
import { ApiService } from 'src/app/services/api.service';
import { UtilService } from 'src/app/services/util/util.service';

@Component({
  selector: 'app-assign-surveyor-detail',
  templateUrl: './assign-surveyor-detail.component.html',
  styleUrls: ['./assign-surveyor-detail.component.css']
})
export class AssignSurveyorDetailComponent implements OnInit {

  kw: any;
  load: boolean = false;
  hasilX: any = {};

  cabang: any = '';
  surveyor: any = '';



  constructor(
    public navParams: NavParams,
    public api: ApiService,
    public util: UtilService
  ) { 
    try {
      this.kw = JSON.parse(this.navParams.data.id);
      console.log('KW', this.kw);
    } catch (error) {
      this.util.showToast('Data Lead_id tidak terparsing', 'danger', 'bottom');
      this.kw = []
    }
  }

  ngOnInit(): void {
    let p  = localStorage.getItem('user') || '';
    if(p !== ''){
      this.cabang = JSON.parse(p).branch_name;
    }
  }

  update() {
    if(!this.load){
    if(this.surveyor == ''){
      this.util.showToast('Surveyor Wajib Diisi','danger','bottom');
      return false;
    }
    this.load = true;
    let param = {
      leads_id: this.kw,
      surveyor: this.surveyor
    }
    this.api.put('backoffice/leads/assign-surveyor', param)
      .subscribe((data) => {
        this.hasilX = data;
        this.load = false;
        this.util.showToast(this.hasilX.message,'success','bottom');
        this.api.dismissData('', 'confirm');
      }, (error) => {
        this.load = false;
        console.log('error', error);
        this.api.errorCond(error);
      });
    }
  }

  handleSelection(selectedValue: string, model: any) {
    if (model == 'surveyor') {
      this.surveyor = selectedValue;
    } 
  }

  batal(){
    this.api.dismiss();
  }


}
